import React from "react";
import styles from "../styles/main.module.scss";

interface IMain {
  desktopLeftMain: React.ReactNode;
  desktopRightMain: React.ReactNode;
  main: React.ReactNode;
}

const Main: React.FC<IMain> = ({ desktopLeftMain, desktopRightMain }) => {
  return (
    <>
      <div className={styles.MainContainer}>
        <div className={styles.SectionLeft}>{desktopLeftMain}</div>
        <div className={styles.SectionRight}>{desktopRightMain}</div>
      </div>
    </>
  );
};
export default Main;
